"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedFiftyBanner = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
const mockedFiftyBanner = exports.mockedFiftyBanner = {
  __typename: 'EditorialFiftyBanner',
  editorialContentType: _editorialFetching.EditorialContentType.FiftyBanner,
  backgroundImage: {
    __typename: 'EditorialBannerImage',
    url: 'https://media-uat-cdn.oriflame.com/contentImage?externalMediaId=ae68bcee-97ff-490e-bc8d-511b640e557e&name=banners3&inputFormat=jpg'
  },
  backgroundType: _editorialFetching.BackgroundType.Image,
  contentAlignment: _editorialFetching.HorizontalContentAlignment.Right,
  id: '9509b24a-fe77-4eb1-a5f5-99b84b158fc9',
  title: 'Main Content Title',
  link: {
    __typename: 'Link',
    id: 'https://google.com',
    relativeUrl: 'https://google.com',
    title: 'Shop now',
    type: _editorialFetching.LinkType.Custom,
    appLink: null
  },
  storybookColor: _editorialFetching.StorybookColor.Green200,
  steps: [{
    __typename: 'EditorialFiftyBannerStep',
    caption: 'Caption 1',
    content: [{
      __typename: 'EditorialBannerText',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nisi magna, vestibulum et sagittis blandit, elementum quis ex. Nullam rhoncus tellus eget quam pharetra, ultricies commodo urna dapibus. Aenean semper erat in odio semper cursus. Sed viverra velit a egestas luctus. Ut maximus tristique turpis, ac convallis lorem dictum ac.',
      textLinks: []
    }]
  }, {
    __typename: 'EditorialFiftyBannerStep',
    caption: 'Caption 2',
    content: [{
      __typename: 'EditorialBannerText',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nisi magna, vestibulum et sagittis blandit, elementum quis ex. Nullam rhoncus tellus eget quam pharetra, ultricies commodo urna dapibus. Aenean semper erat in odio semper cursus. Sed viverra velit a egestas luctus. ',
      textLinks: []
    }]
  }, {
    __typename: 'EditorialFiftyBannerStep',
    caption: 'Caption 3',
    content: [{
      __typename: 'EditorialBannerText',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nisi magna, vestibulum et sagittis blandit, elementum quis ex. Nullam rhoncus tellus eget quam pharetra, ultricies commodo urna dapibus. ',
      textLinks: []
    }]
  }, {
    __typename: 'EditorialFiftyBannerStep',
    caption: 'Caption 4',
    content: [{
      __typename: 'EditorialBannerText',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. ',
      textLinks: []
    }]
  }, {
    __typename: 'EditorialFiftyBannerStep',
    caption: 'Caption 5',
    content: [{
      __typename: 'EditorialBannerText',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nisi magna, vestibulum et sagittis blandit, elementum quis ex. Nullam rhoncus tellus eget quam pharetra, ultricies commodo urna dapibus. ',
      textLinks: []
    }]
  }]
};
